import React from "react";
import {
  Box,
  Container,
  Heading,
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
} from "@chakra-ui/react";

export default function FAQ() {
  return (
    <Box as="section" bg="black" color="white" py={16}>
      <Container maxW="4xl" px={{ base: 6, md: 8 }}>
        <Heading as="h2" size="lg" textAlign="center" mb={6}>FAQ</Heading>
        <Accordion allowMultiple>
          {[
            ["How fast can you start a penetration test?",
             "We can usually begin scoping within 24 hours and start testing within 5 to 7 business days, depending on complexity."],
            ["Do you include a remediation re-test?",
             "Yes. A complimentary re-test within 30 days verifies fixes and updates your report for stakeholders."],
            ["Can you help us get ISO 27001 certified?",
             "Yes we can, we'll start with a Gap Assessments, Provide an Implementation Project Plan, Policy and Procedure Development, Assist with Evidence Collection, Schedule Internal Audits and provide audit readiness to support ISO 27001 certification."],
          ].map(([q, a]) => (
            <AccordionItem key={q}>
              <AccordionButton>
                <Box as="span" flex="1" textAlign="left">{q}</Box>
                <AccordionIcon />
              </AccordionButton>
              <AccordionPanel pb={4}>{a}</AccordionPanel>
            </AccordionItem>
          ))}
        </Accordion>
      </Container>
    </Box>
  );
}
